import type { ShellUser } from './Header';

/**
 * Profile avatar: the applicant's account photo when present (populated by
 * Globus from the personal_information step, or a later Profile-page update),
 * falling back to their initials. One markup everywhere an avatar appears so
 * the photo stays consistent across the sidebar, account menu and drawer.
 */
export default function Avatar({ user, className = '' }: { user: ShellUser; className?: string }) {
  const cls = `avatar${className ? ` ${className}` : ''}`;
  return user.avatarUrl ? (
    <img className={cls} src={user.avatarUrl} alt="" />
  ) : (
    <span className={cls} aria-hidden>{user.initials}</span>
  );
}
